import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subpageAction", "image", "indexImage"];
  static classes = ["js"];

  idAttrSelector = "data-page-id";
  timeout;

  connect() {
    this.element.classList.add(this.jsClass || "js");
  }

  hover(event) {
    /** @type {HTMLAnchorElement} */
    const action = event.currentTarget;
    const id = action.getAttribute(this.idAttrSelector);

    if (!id) {
      console.log("No ID assigned");
      return;
    }

    /** @type {HTMLImageElement|null} */
    const image = this.imageTargets.find(
      (element) => element.getAttribute(this.idAttrSelector) === id
    );

    if (!image) {
      console.log("No image with same ID found");
      return;
    }

    const indexImage = this.indexImageTarget;

    if (indexImage) {
      indexImage.setAttribute("style", "display: none");
    }

    const hideOtherImages = () => {
      this.imageTargets
        .filter((imageTarget) => imageTarget !== image)
        .forEach((element) => {
          element.setAttribute("style", "display: none");
        });
    };

    hideOtherImages();

    const imgLoaded = () => {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        image.setAttribute("style", "opacity: 1");
      }, 100);

      image.setAttribute("data-loaded", "true");
    };

    if (!image.getAttribute("data-loaded")) {
      image.onload = () => imgLoaded();
      image.setAttribute("style", "opacity: 0");

      if (image.complete || image.naturalWidth !== 0) {
        imgLoaded();
      }
    } else {
      image.setAttribute("style", "opacity: 0");
      imgLoaded();
    }
  }
}
